require('./build/loading-bar');
module.exports = 'angular-loading-bar';



//////////////////
// WEBPACK FOOTER
// ./~/angular-loading-bar/index.js
// module id = 103
// module chunks = 0